import { render, staticRenderFns } from "./FailedEmailList.vue?vue&type=template&id=32bcda22&scoped=true"
import script from "./FailedEmailList.vue?vue&type=script&lang=js"
export * from "./FailedEmailList.vue?vue&type=script&lang=js"
import style0 from "./FailedEmailList.vue?vue&type=style&index=0&id=32bcda22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bcda22",
  null
  
)

export default component.exports